import { render, staticRenderFns } from "./IntegrationsFilter.vue?vue&type=template&id=f4b33f38"
import script from "./IntegrationsFilter.vue?vue&type=script&lang=js"
export * from "./IntegrationsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports